<template>
  <div class="relative mb-4">
    <div
      class="p-3 bg-white cursor-pointer wrapped-dropdown" :class="{ 'opened': isOpen }"
      @click="toggleDropdown">
      {{ selected || placeholder }}
      <svg id="drp-arrow" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" class="arrow transition-all ml-auto rotate-180" :class="{ 'rotated': isOpen }">
        <path d="M7 14.5l5-5 5 5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>
      </svg>
    </div>

    <ul
      v-if="isOpen"
      class="dropdown absolute z-10 mt-1 w-full bg-white border rounded shadow">
      <li
        v-for="option in options"
        :key="option"
        @click="selectOption(option)"
        class="dropdown-item p-2 hover:bg-gray-100 cursor-pointer">
        {{ option }}
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'CustomDropdown',
  props: {
    options: Array,
    placeholder: {
      type: String,
      default: 'Select an option'
    }
  },
  data () {
    return {
      isOpen: false,
      selected: null
    }
  },
  methods: {
    toggleDropdown () {
      this.isOpen = !this.isOpen
    },
    selectOption (option) {
      this.selected = option
      this.isOpen = false
      this.$emit('update:selected', option) // for two-way binding
    },
    handleClickOutside (event) {
      if (!this.$el.contains(event.target)) {
        this.isOpen = false
      }
    }
  },
  mounted () {
    // Close dropdown when clicking outside
    document.addEventListener('click', this.handleClickOutside)
  },
  beforeDestroy () {
    document.removeEventListener('click', this.handleClickOutside)
  }
}
</script>

<style scoped>
.wrapped-dropdown{
  border-radius: 8px;
}

.arrow {
  margin-left: 10px;
  float: right;
  rotate: 180deg;
  transition: all 0.3s;

  path {
     fill: transparent !important;
  }
}

.rotated {
  transform: rotate(-180deg);
}

</style>
